import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from 'core/core.module';
import { MessagesService } from './messages.service';
import { MessagesListComponent } from './messages-list/messages-list.component';
import { MessagesListRowComponent } from './messages-list/messages-list-row/messages-list-row.component';
import { MessageCreateComponent } from './message-create/message-create.component';

@NgModule({
  imports: [CommonModule, CoreModule],
  declarations: [MessagesListComponent, MessagesListRowComponent, MessageCreateComponent],
  exports: [MessagesListComponent],
  providers: [MessagesService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MessagesModule {}
